import styled from 'styled-components';

type S = { $scrolled: boolean; $fullOnMobile?: boolean };

export const LogoLink = styled.div<S>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: ${p => (p.$scrolled ? '36px' : '164px')};
  transition: width 400ms cubic-bezier(0.4, 0, 0.2, 1);

  @media screen and (max-width: 767px) {
    width: ${p => (p.$fullOnMobile ? '132px' : '32px')};
    height: 30px;
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    width: ${p => (p.$scrolled ? '34px' : '148px')};
    height: 32px;
  }
`;

export const FullLogo = styled.img<S>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 164px;
  opacity: ${p => (p.$scrolled ? 0 : 1)};
  transition: opacity 300ms ease;
  pointer-events: none;

  @media screen and (max-width: 767px) {
    width: 132px;
    opacity: ${p => (p.$fullOnMobile ? 1 : 0)};
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    width: 148px;
  }
`;

export const IconLogo = styled.img<S>`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 30px;
  opacity: ${p => (p.$scrolled ? 1 : 0)};
  transition: opacity 300ms ease;
  pointer-events: none;

  @media screen and (max-width: 767px) {
    opacity: ${p => (p.$fullOnMobile ? 0 : 1)};
  }

  @media screen and (min-width: 768px) and (max-width: 1279px) {
    height: 32px;
  }
`;
